import * as Yup from 'yup'

const emailIdOrBlankRegex = /(^$|^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(?:[a-zA-Z]{2}|com|org|net|edu|gov|mil|biz|info|mobi|name|aero|asia|jobs|museum)$)/

export const hasLowerCase = (str: string): boolean => {
  return /[a-z]/.test(str)
}

export function isEmpty(str: string): boolean {
  return !str || str.length === 0
}

export const mobileNumber = Yup.string()
  .required('Required')
  .min(10, 'Mobile number must be 10 digits')
  .max(10, 'Mobile number must be 10 digits')
  .matches(/^\d{10}$/, 'Only 10 digit mobile number allowed')

export const mobileNumberOrBlank = Yup.string()
  .max(10, 'Mobile number must be 10 digits')
  .matches(/(^$)|(^\d{10}$)/, 'Only 10 digit mobile number allowed')

export const numberValidation = Yup.string()
  .required('Required')
  .min(1, 'Please enter a number')
  .matches(/^[0-9]*$/, 'Only digits 0-9 are allowed.')

export const numberValidationWithDecimal = Yup.string()
  .required('Required')
  .min(1, 'Please enter a number')
  .matches(/^\d*(\.)?(\d{0,2})?$/, 'Only digits 0-9 are allowed with optional 2 digits decimal.')

export const alphaNumericValidation = Yup.string()
  .required('Required')
  .matches(/^[a-zA-Z0-9]+$/, 'Only alpha numeric accepted')

export const bankAlphaNumericValidation = Yup.string()
  .required('Required')
  .min(8, 'Please enter complete account number.')
  .max(25, 'Exceeded the maximum account number length.')
  .matches(/^[a-zA-Z0-9]+$/, 'Only alpha numeric accepted')

export const emailOrBlankString = Yup.string().matches(emailIdOrBlankRegex, 'Invalid email ID')

export const required = Yup.string().trim().required('Required!')

export const Name = Yup.string()
  .trim()
  .min(2, 'Too Short Name!')
  .max(50, 'Too Long Name!')
  .required('Required')
  .matches(/^[a-zA-Z]+(\s[a-zA-Z]+)?$/, 'Only Alphabets are allowed.')

export const email = Yup.string().trim().email('Invalid email').required('Required')

export const otpSixDigit = Yup.string().trim().min(6, 'Enter correct OTP!').required('Required')

export const GSTValidation = Yup.string()
  .trim()
  .matches(/[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[1-9A-Z]{1}$/, 'Is not in correct format')
  .required()

export const panValidation = Yup.string()
  .trim()
  .matches(/[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Incorrect Pan Number')
  .required()

export const aadharNumberValidation = Yup.string()
  .trim()
  .min(12, 'Enter correct Aadhar Number!')
  .required('Required')
  .matches(/^\d{12}$/, 'Incorrect Aadhar')

export const pincodeValidation = Yup.string()
  .trim()
  .required('Required')
  .min(6, 'Please enter 6 digit pincode')
  .matches(/^\d{6}$/, 'Incorrect pincode')

export const addressValidation = Yup.string()
  .trim()
  .required('Required')
  .min(10, 'Too Short Address!')
  .max(150, 'Please enter correct address!')

export const amountValidation = Yup.string()
  .trim()
  .required('Required')
  .min(1, 'Please enter a number')
  .matches(/^\d+(\.\d{1,2})?$/, 'Please enter correct amount.')

export const bankAccountValidation = Yup.string()
  .trim()
  .matches(/^\d{9,18}$/, 'Incorrect Account Number')
  .required()

export const bankIFSCValidation = Yup.string()
  .trim()
  .matches(/^[A-Z]{4}[A-Z0-9]{7}$/, 'Incorrect IFSC code')
  .required()

let textOldValue = ''
export const expiryDateValidationText = (text: string) => {
  // to detect cases of deletion
  textOldValue = textOldValue.length < text.length ? text : ''

  const slash = text.indexOf('/')
  const expiryDate = slash > -1 ? text.split('').splice(slash, 1) : text.split('')
  if (expiryDate.length > 1 && textOldValue.length > 1) {
    return Number(expiryDate[0]) > 1
      ? `0${expiryDate[0]}/${expiryDate[1]}${expiryDate[2] ? expiryDate[2] : ''}`
      : `${expiryDate[0]}${expiryDate[1]}/${expiryDate[2] ? expiryDate[2] : ''}${expiryDate[3] ? expiryDate[3] : ''}`
  }
  return text
}

export const isValidCardNumber = (value: string) => {
  let nCheck = 0
  let bEven = false

  if (value) {
    for (let n = value.length - 1; n >= 0; n -= 1) {
      const cDigit = value.charAt(n)
      let nDigit = parseInt(cDigit, 10)

      if (bEven) {
        nDigit *= 2
        if (nDigit > 9) {
          nDigit -= 9
        }
      }

      nCheck += nDigit
      bEven = !bEven
    }
  }
  return nCheck % 10 === 0
}

export const cardNumber = Yup.string()
  .min(12, 'Minimum 12 digits required')
  .required('Required')
  .test('Test if its a valid', 'Please enter a valid credit/debit card number', (value: string) => {
    return isValidCardNumber(value)
  })
export const TwoInputSchema = (field1: string, field2: string) =>
  Yup.string()
    .required('Required')
    .test('Test if its a valid', `Enter both ${field1} and ${field2}`, (value: any) => {
      const splitValues = value?.split('_') ?? []
      if (splitValues.length === 1) {
        return splitValues[0] && splitValues[0] !== '0'
      }

      return splitValues[0] && splitValues[0] !== '0' && splitValues[1] && splitValues[1] !== '0'
    })

export const expiry = Yup.string()
  .min(4, 'Enter valid 4 digits')
  .required('Required')
  .matches(/^[0-1][0-9]\/[0-9][0-9]$/, 'Invalid Date (mm/yy). Starting digit must be 0 or 1 eg: 09/19')
  .test('Test if its a valid', 'Month should be less than or equal to 12 and greater than 0', (value: string) => {
    if (!value) {
      return false
    }
    const monthStr = value.split('/')[0]
    const month = Number(monthStr)
    if (isNaN(month)) {
      return false
    }
    const ret = month < 13 && month > 0
    return ret
  })
  .test('Test if its a future date', 'Expiry date should be future date', (value: string) => {
    if (!value) {
      return false
    }
    const monthStr = value.split('/')[0]
    const yearStr = value.split('/')[1]
    if (!monthStr || !yearStr) {
      return false
    }
    const month = Number(monthStr)
    const year = Number(`20${yearStr}`)
    if (isNaN(month) || isNaN(year)) {
      return false
    }
    const today = new Date()

    return year > today.getFullYear() || (year === today.getFullYear() && month >= today.getMonth() + 1)
  })
  .test('Test if its a future date', 'Expiry date should be less than 10 years', (value: string) => {
    if (!value) {
      return false
    }
    const yearStr = value.split('/')[1]
    if (!yearStr) {
      return false
    }
    const year = Number(`20${yearStr}`)
    if (isNaN(year)) {
      return false
    }
    const today = new Date()
    const MAX_EXPIRY_YEARS = 10
    return today.getFullYear() + MAX_EXPIRY_YEARS > year ? true : false
  })

export const DOB = Yup.string()
  .required('Required')
  .matches(/^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/, 'Invalid Date of birth ')

export const Password = Yup.string()
  .required('Required')
  .matches(
    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/,
    'Password should contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character',
  )
